/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { InfoSquareIcon16Light } from './InfoSquareIcon16Light';
import { InfoSquareIcon16Regular } from './InfoSquareIcon16Regular';
import { InfoSquareIcon16Solid } from './InfoSquareIcon16Solid';
import { InfoSquareIcon20Light } from './InfoSquareIcon20Light';
import { InfoSquareIcon20Regular } from './InfoSquareIcon20Regular';
import { InfoSquareIcon20Solid } from './InfoSquareIcon20Solid';
import { InfoSquareIcon24Regular } from './InfoSquareIcon24Regular';
import { InfoSquareIcon24Solid } from './InfoSquareIcon24Solid';
import { InfoSquareIcon32Regular } from './InfoSquareIcon32Regular';
import { InfoSquareIcon64Regular } from './InfoSquareIcon64Regular';
var sizes = {
    16: {
        light: InfoSquareIcon16Light,
        regular: InfoSquareIcon16Regular,
        solid: InfoSquareIcon16Solid,
    },
    20: {
        light: InfoSquareIcon20Light,
        regular: InfoSquareIcon20Regular,
        solid: InfoSquareIcon20Solid,
    },
    24: {
        regular: InfoSquareIcon24Regular,
        solid: InfoSquareIcon24Solid,
    },
    32: {
        regular: InfoSquareIcon32Regular,
    },
    64: {
        regular: InfoSquareIcon64Regular,
    },
};
export var InfoSquareIcon = forwardRef('InfoSquareIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
